module.exports = __webpack_public_path__ + "assets/img/telegram.17461bbf.svg";